import React from "react"
import { Box } from "rebass"

const MaxWidth = (props) => (
  <Box {...props} mx="auto" style={{ maxWidth: "90rem", width: "100%" }} />
)

export default MaxWidth
